import React from 'react';
import { Check, Mail, HelpCircle, ShieldCheck, Lock, Star, PlayCircle } from 'lucide-react';
const CTAButton = ({
  className = ''
}: {
  className?: string;
}) => <div data-id="element-3475" data-mp="il18scf9vzdp">
    <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className={`block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-4 px-4 rounded-lg text-center transition-colors shadow-lg ${className}`} data-id="element-3476" data-mp="ilaxzxshu2ic">
      <span className="block text-sm font-normal mb-1" data-id="element-3477" data-mp="8twtfbloqcic">Ga naar stap #2</span>
      <span className="block text-xl" data-id="element-3478" data-mp="dmpwlv1i9csb">Start de aanpak nu</span>
    </a>
    <img src="https://cdn.magicpatterns.com/uploads/4vdV4HP3iomaCgiRo35kk3/ORAweI9onQltdmefOLBalrxDMg.png" alt="Betaalmethoden: Mastercard, CB, Apple Pay, iDEAL, SEPA, Visa, PayPal, American Express, Klarna, Bancontact" className="mx-auto mt-3 h-10 w-auto max-w-[280px] opacity-80" data-id="element-3479" data-mp="3v2xzlckje9eg" />
  </div>;
const PricingCard = () => <div className="bg-white rounded-xl shadow-xl p-6 border-t-8 border-[#5ce0d2] text-center flex flex-col h-full" data-id="element-3480" data-mp="3r01dvczp9x6a">
    <h3 className="text-[#5ce0d2] font-extrabold text-2xl mb-1 uppercase tracking-wide" data-id="element-3481" data-mp="303bu4tx0f35q">
      Nu nog beschikbaar
    </h3>
    <h2 className="text-4xl font-black text-[#1a2b4a] mb-6" data-id="element-3482" data-mp="39z6im5nwzsgf">Start vandaag</h2>

    <div className="mb-6" data-id="element-3483" data-mp="39x2h1udhn5jb">
      <img src="https://cdn.magicpatterns.com/uploads/vxv92giZwb84avmwkmhTZx/Scherm­afbeelding_2026-04-12_om_21.51.15.png" alt="Verlatingsangst Kernaanpak - training op laptop, tablet en telefoon" className="w-full h-auto object-contain" data-id="element-3484" data-mp="34ztwjn4vapew" />
    </div>

    <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-3485" data-mp="2r0kfymcr1tae">Nu voor €27</div>
    <div className="text-[#e53e3e] font-bold text-lg mb-6" data-id="element-3486" data-mp="2r2ngi0bj34td">(Bespaar €70)</div>

    <p className="text-sm text-gray-600 mb-6 leading-relaxed" data-id="element-3487" data-mp="2m89gtlpu2biw">
      Start met de Verlatingsangst Kernaanpak voor €27 in plaats van{' '}
      <span className="line-through" data-id="element-3488" data-mp="1yhx3fvbtjmkx">€97</span>. Per direct toegang. Start
      binnen de 3 minuten.
    </p>

    <p className="text-[#22c55e] font-bold text-sm mb-6" data-id="element-3489" data-mp="3tnfzb16if3l3">
      Nu beschikbaar voor directe toegang
    </p>

    <CTAButton className="mb-4" data-id="element-3490" data-mp="2gv73e4pxpmh" />

    <div className="text-xs text-gray-500 space-y-2 mt-auto pt-4" data-id="element-3491" data-mp="2ftwtbvj175t">
      <p className="flex items-center justify-center gap-1" data-id="element-3492" data-mp="77bof9bntve4">
        <Lock className="w-4 h-4" data-id="element-3493" data-mp="79y45w8pfh7f" /> 100% veilig afrekenen
      </p>
      <p className="flex items-center justify-center gap-1" data-id="element-3494" data-mp="b85cq3t0lc7j">
        <ShieldCheck className="w-4 h-4" data-id="element-3495" data-mp="3aotx1iz9b6fl" /> Met onze 100% geld terug garantie
      </p>
    </div>
  </div>;
export function VerlatingsangstPage() {
  return <div className="min-h-screen bg-[#faf5eb] font-sans text-gray-800 pb-24 md:pb-0" data-id="element-3496" data-mp="3fnwzqwrrl0ke">
      {/* 1. HEADER */}
      <div className="bg-[#e6f7f5] py-3 px-4" data-id="element-3497" data-mp="3jrcs3gwswera">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-3498" data-mp="3oolddqd8wywr">
          <div className="flex-1 hidden md:block" data-id="element-3499" data-mp="yxzo0gxoqspo"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-3500" data-mp="13y44i6ylfnfw" />
          <div className="flex-1 flex justify-center md:justify-end" data-id="element-3501" data-mp="192of6xrn372k">
            <a href="mailto:amee@stresslessdogs.nl" className="flex items-center text-sm font-bold text-[#1a2b4a] hover:text-[#5ce0d2] transition-colors" data-id="element-3502" data-mp="14c7y93om13bg">
              <Mail className="w-5 h-5 mr-2" data-id="element-3503" data-mp="vbjnchuijj2s" />
              Hulp nodig? Email mij{' '}
              <span className="text-blue-600 ml-1 underline" data-id="element-3504" data-mp="v96xliiik4f6">HIER.</span>
            </a>
          </div>
        </div>
      </div>

      {/* 2. BLACK BANNER */}
      <div className="bg-black text-white text-center py-4 px-4 font-bold text-sm md:text-base tracking-wide" data-id="element-3505" data-mp="le58gmo8n2cl">
        Voor baasjes die hun hond willen bevrijden van zijn verlatingsangst (en
        zichzelf ook)
      </div>

      {/* 3. HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-16" data-id="element-3506" data-mp="2bq2rk6q35yll">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-[#1a2b4a] text-center mb-6 leading-tight" data-id="element-3507" data-mp="2bnoxo1756sfm">
          Oefenen is niet genoeg: Hoe je de echte oorzaak van verlatingsangst in
          3 stappen oplost
        </h1>
        <p className="text-lg md:text-2xl text-center text-gray-700 mb-12 max-w-4xl mx-auto font-medium leading-relaxed" data-id="element-3508" data-mp="29sl4ip5x3mso">
          Zodat je hond zonder stress alleen thuis kan blijven, jij je vrijheid
          terugkrijgt, en je nooit meer bang hoeft te zijn dat je buren klagen.
        </p>

        <div className="grid md:grid-cols-12 gap-8 items-start" data-id="element-3509" data-mp="24syiprc0wy89">
          <div className="md:col-span-8" data-id="element-3510" data-mp="24vb98svukgwx">
            <div className="rounded-xl overflow-hidden shadow-2xl bg-black border-4 border-white" data-id="element-3511" data-mp="1q4u7f8favozi">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-3512" data-mp="1v2vsfywadydm">
                <iframe src="https://player.vimeo.com/video/1165482241?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="Hero Video" data-id="element-3513" data-mp="1h5qmdywkozid"></iframe>
              </div>
            </div>
            <p className="text-center text-sm text-gray-500 mt-3 underline cursor-pointer" data-id="element-3514" data-mp="1lerj13nkoohy">
              Klik op afspelen om de video te starten
            </p>

            {/* Wat is de nieuwe Verlatingsangst Kernaanpak? - direct under video */}
            <div className="mt-8" data-id="element-3515" data-mp="1v7fffxan4qg5">
              <h2 className="text-3xl font-bold text-[#5ce0d2] mb-4 text-center" data-id="element-3516" data-mp="1q69jzrplip2x">
                Wat is de nieuwe Verlatingsangst Kernaanpak?
              </h2>
              <div className="text-lg text-gray-700 leading-relaxed space-y-4" data-id="element-3517" data-mp="243y4uzjnxw7z">
                <p data-id="element-3518" data-mp="1z90wzvy4dswo">
                  De Verlatingsangst Kernmethode is een stap voor stap aanpak
                  die hondenbaasjes helpt om de echte oorzaak van de spanning
                  van hun hond te herkennen, te begrijpen en blijvend op te
                  lossen.
                </p>
                <p data-id="element-3519" data-mp="15t6qow2w291p">
                  We laten je precies zien waardoor de spanning bij jouw hond
                  ontstaat en hoe je op basis daarvan een gericht trainingsplan
                  maakt dat de verlatingsangst bij het onderliggende probleem
                  aanpakt.
                </p>
                <p className="font-bold text-[#1a2b4a]" data-id="element-3520" data-mp="1khjeh5rtoll4">
                  Zodat je dit niet tijdelijk, maar echt voorgoed oplost.
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-4" data-id="element-3521" data-mp="1thyaaz2exj2v">
            <PricingCard data-id="element-3522" data-mp="3raby755dk3r4" />
          </div>
        </div>
      </section>

      {/* 6. VOOR WIE WERKT DIT */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-3523" data-mp="3vanksnhase58">
        {/* 6. VOOR WIE WERKT DIT */}
        <div className="bg-white rounded-xl shadow-md p-8 mb-12 border border-gray-100" data-id="element-3524" data-mp="3ns66m3yh8b5x">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-3525" data-mp="3j0o5nfwgeaky">
            Voor wie werkt dit
          </h3>
          <p className="mb-6 text-gray-700" data-id="element-3526" data-mp="3e1bl51t21flj">
            Voor alle baasjes die honden met verlatingsangst die in paniek raken
            als hun baasje ze thuis achter laat:
          </p>
          <ul className="space-y-4" data-id="element-3527" data-mp="alwabycur1zc">
            {['Het maakt niet uit als je nog nooit eerder met je hond hebt getraind.', 'De methode is eenvoudig en praktisch, zodat iedereen ermee aan de slag kan.', 'Geschikt voor honden van alle leeftijden en alle formaten.', 'Werkt ook bij speciale honden of honden met een rugzakje'].map((item, i) => <li key={i} className="flex items-start" data-id="element-3528" data-mp="2mbylfixct5vt" data-mpi={i}>
                <Check className="w-6 h-6 text-[#22c55e] mr-3 flex-shrink-0 mt-0.5" data-id="element-3529" data-mp="2hbu3rpkpm540" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-3530" data-mp="2hdx1yww0n4jt">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {/* 7. MET DE METHODE */}
        <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-3531" data-mp="bai024e99uyb">
          Met de Verlatingsangst Kernmethode…
        </h3>
        <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-3532" data-mp="g93289d2iope">
          <p data-id="element-3533" data-mp="13z72c6r1s6bn">
            ...zal je het blaffen, piepen, huilen en slopen van je hond als jij
            vertrekt in drie stappen verminderen door het onderliggende probleem
            op te lossen dat er nu voor zorgt dat hij terugvalt.
          </p>
          <p data-id="element-3534" data-mp="u8ulopmcsxas">Waardoor hij niet zal terugvallen en het oefenen sneller gaat.</p>
          <p className="font-bold text-[#1a2b4a]" data-id="element-3535" data-mp="z7fc5xbt02m1">
            Geen gevoel dat je keihard samen oefent maar nergens komt.
          </p>
        </div>

        <div className="mb-12 rounded-xl overflow-hidden shadow-lg" data-id="element-3536" data-mp="1mw8bm3rmwsle">
          <img src="https://cdn.magicpatterns.com/uploads/vZLarCb4ynRSjgCisN7z8e/freepik_middelgrote-hond-in-een-g_2777443833.png" alt="Hond ontspannen op de bank terwijl baasje weggaat" className="w-full h-auto object-cover" data-id="element-3537" data-mp="1rqchskt2swlf" />
        </div>

        {/* 8. SIGNALEN */}
        <div className="bg-[#e6f7f5] rounded-xl p-8 mb-12" data-id="element-3538" data-mp="3l9l7p3ge989e">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-3539" data-mp="3h6yb6p8s2z5v">
            Signalen dat je hond verlatingsangst heeft
          </h3>
          <ul className="space-y-4" data-id="element-3540" data-mp="2tif3aatn4oeb">
            {['Piept, blaft of krijgt spanning als jij wilt vertrekken', 'Stopt niet als je eenmaal van huis bent', 'In huis plassen of poepen terwijl hij zindelijk is', 'Slopen, krabben of bijten aan meubels of deuren', 'Andere signalen van spanning als je van huis weg gaat'].map((item, i) => <li key={i} className="flex items-start" data-id="element-3541" data-mp="crp4oek4clsd" data-mpi={i}>
                <Check className="w-6 h-6 text-[#5ce0d2] mr-3 flex-shrink-0 mt-0.5" data-id="element-3542" data-mp="cr5kssawrnbp" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-3543" data-mp="2mlm77uhiou75">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </section>

      {/* 9. FULL WIDTH PRICING CTA */}
      <section className="bg-white py-16 border-y border-gray-200" data-id="element-3544" data-mp="2curgodx8n8fw">
        <div className="max-w-4xl mx-auto px-4" data-id="element-3545" data-mp="28uhbv4l6mo2m">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-3546" data-mp="23w61msqz6bjv">
            <div data-id="element-3547" data-mp="23xh66us8vnc1">
              <h2 className="text-3xl font-black text-[#1a2b4a] mb-4" data-id="element-3548" data-mp="23ttb3r75isv7">
                Start vandaag
              </h2>
              <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-3549" data-mp="1txq9cmg7ow8s">
                Nu voor €27
              </div>
              <div className="text-[#e53e3e] font-bold text-lg mb-4" data-id="element-3550" data-mp="1px6e5of782pa">
                (Bespaar €70)
              </div>
              <p className="text-gray-600 mb-6" data-id="element-3551" data-mp="3oapxj3ynqyro">
                Start met de Verlatingsangst Kernaanpak voor €27 in plaats van{' '}
                <span className="line-through" data-id="element-3552" data-mp="3k8bgmpeju931">€97</span>. Per direct toegang.
                Start binnen de 3 minuten.
              </p>
            </div>
            <div data-id="element-3553" data-mp="1b0ptopapf4ik">
              <CTAButton data-id="element-3554" data-mp="1b06n24qi82ju" />
              <div className="text-xs text-gray-500 space-y-2 mt-4 text-center" data-id="element-3555" data-mp="1azeoqm5ivqpv">
                <p className="flex items-center justify-center gap-1" data-id="element-3556" data-mp="1ft9fuangj7yz">
                  <Lock className="w-4 h-4" data-id="element-3557" data-mp="1jt06meczho3i" /> 100% veilig afrekenen
                </p>
                <p className="flex items-center justify-center gap-1" data-id="element-3558" data-mp="n4kfidu876oa">
                  <ShieldCheck className="w-4 h-4" data-id="element-3559" data-mp="s2lvur09orw2" /> Met onze 100% geld terug
                  garantie
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 10. DETAILED EXPLANATION + SIDEBAR */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-3560" data-mp="1154vl28raoe3">
        <div className="grid lg:grid-cols-12 gap-8" data-id="element-3561" data-mp="27k5ikifszw8j">
          {/* Left column - main content */}
          <div className="lg:col-span-8" data-id="element-3562" data-mp="2ci7cjyerpfys">
            <h2 className="text-3xl font-bold text-[#5ce0d2] mb-6" data-id="element-3563" data-mp="2ch5pswoe3518">
              Wat is de nieuwe Verlatingsangst Kernaanpak?
            </h2>
            <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-3564" data-mp="8f5s5e7852hz">
              <p data-id="element-3565" data-mp="8h8jq2o0z3ot">
                Oefenen heeft pas zin als je het onderliggende probleem eerst
                oplost.
              </p>
              <p data-id="element-3566" data-mp="hfap0ueskihw">
                Doe je dat niet, dan komt dat kernprobleem vroeg of laat weer
                naar boven. En dan leert je hond opnieuw dat er vervelende
                dingen gebeuren als hij alleen is.
              </p>
              <p data-id="element-3567" data-mp="3ky3vyod2e933">
                Sommige onderliggende kernproblemen komen snel en vaak omhoog,
                waardoor je met oefenen niet verder komt dan een paar minuten.
              </p>
              <p data-id="element-3568" data-mp="3ut5mnomznj7s">
                Andere kernproblemen zijn er minder vaak. Waardoor het na
                maanden oefenen lijkt te lukken om je hond 20 minuten alleen te
                laten, maar dan gebeurt er iets en ben je weer helemaal terug
                bij af.
              </p>
              <p className="font-medium" data-id="element-3569" data-mp="1hm7h1x50cxqy">
                Daarom moet je eerst het onderliggende probleem oplossen. Dit is
                hoe het werkt.
              </p>
            </div>

            {/* 11. 3 STEPS */}
            <div className="mb-8 rounded-xl overflow-hidden" data-id="element-3570" data-mp="18kzkbji544yz">
              <img src="https://cdn.magicpatterns.com/uploads/gZydPdwYJ47daE8nNYhLdq/9b6d1fe9789894c2655050948709230b.png" alt="Oude Aanpak vs De Nieuwe Verlatingsangst Kernaanpak" className="w-full h-auto object-contain rounded-lg" data-id="element-3571" data-mp="1cpgzf5dk1u3f" />
            </div>
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-8 text-center" data-id="element-3572" data-mp="1rd24v5xwk5ei">
              Kernprobleem oplossen in drie stappen
            </h2>
            <div className="space-y-8 mb-16" data-id="element-3573" data-mp="fyokwc69sa3r">
              {[{
              title: 'Stap 1: Diagnose',
              text: 'De eerste stap is begrijpen welke van de vijf onderliggende kernproblemen er bij jouw hond spelen. En hiervoor moet je een diagnose doen.'
            }, {
              title: 'Stap 2: Behandelplan',
              text: 'De tweede stap is om het kernprobleem dat de echte oorzaak is van zijn verlatingsangst aan te pakken via een behandelplan dat jij als baasje zelfstandig kan uitvoeren. Vaak duurt dit twee weken waarin je dagelijks wat kleine oefeningen doet die zich richten op het kernprobleem.'
            }, {
              title: 'Stap 3: Oefenen',
              text: 'En als je zeker weet dat hij er klaar voor is… Dan ga je als derde stap oefenen. Simpel. Door deze voorbereiding maak je tijdens het oefenen grotere stappen met veel minder risico op een terugval. Het echte probleem heb je namelijk opgelost en je hoeft nog alleen het bestaande patroon te doorbreken.'
            }].map((step, i) => <div key={i} className="flex gap-6 items-start" data-id="element-3574" data-mp="3puvs6o5sy2tk" data-mpi={i}>
                  <div className="w-12 h-12 rounded-full bg-[#5ce0d2] text-white flex items-center justify-center font-bold text-2xl flex-shrink-0 mt-1" data-id="element-3575" data-mp="25f7empnn0i7g">
                    {i + 1}
                  </div>
                  <div data-id="element-3576" data-mp="2ee1hgxrka4tg">
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-3577" data-mp="2edj9x4zg8468">
                      {step.text}
                    </p>
                  </div>
                </div>)}
            </div>
            <p className="text-lg text-gray-700 leading-relaxed mb-4 font-medium" data-id="element-3578" data-mp="2o4noi3l7pn0j">
              Op deze manier kan zelfs een hond die al in paniek schiet als jij
              van de bank op staat leren om stressvrij alleen thuis te blijven
              zodat jij even kan sporten, een boodschap kan doen, of iets anders
              wat voor de meeste mensen gewoon heel normaal is.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-8 font-medium" data-id="element-3579" data-mp="13r5aogsyqmjy">
              Zonder gepiep, geblaf of gehuil.
            </p>

            <div className="mb-16 rounded-xl overflow-hidden shadow-lg" data-id="element-3580" data-mp="2b0rw7zoippv4">
              <img src="https://cdn.magicpatterns.com/uploads/c5dwivjBuf94wiUeGKtu3j/freepik_man-en-vrouw-van-rond-de-_2777480988.png" alt="Man en vrouw verlaten ontspannen hun huis met hond op de achtergrond" className="w-full h-auto object-cover" data-id="element-3581" data-mp="262gobuhs9pfj" />
            </div>

            {/* 12. ICEBERG */}
            <div className="bg-[#1a2b4a] text-white rounded-2xl p-8 md:p-12 mb-16 shadow-2xl" data-id="element-3582" data-mp="2tyunym8ga0wm">
              <h2 className="text-3xl font-bold text-[#5ce0d2] mb-8 text-center" data-id="element-3583" data-mp="2p0t6u6ul4bns">
                Waarom deze methode werkt juist als nog niks gewerkt heeft
              </h2>
              <div className="flex items-center gap-5 mb-10 max-w-2xl mx-auto" data-id="element-3584" data-mp="2ys72g3jf0rbn">
                <blockquote className="text-xl italic text-gray-300 border-l-4 border-[#5ce0d2] pl-4 flex-1" data-id="element-3585" data-mp="3cqduh31onx3e">
                  "De geest is als een ijsberg. Slechts een klein deel is
                  zichtbaar boven het water." - Sigmund Freud
                </blockquote>
                <img src="https://cdn.magicpatterns.com/uploads/qmwWHyfVMxLgrevSP4D47H/sigmund.jpg" alt="Sigmund Freud" className="w-20 h-20 rounded-full object-cover flex-shrink-0 border-2 border-[#5ce0d2]" data-id="element-3586" data-mp="7b2o26f8rle" />
              </div>

              <div className="space-y-6 text-gray-200 text-lg leading-relaxed" data-id="element-3587" data-mp="38n4j6h0r632g">
                <p data-id="element-3588" data-mp="38l1ldatcz5n6">
                  Het huilen, blaffen of piepen als jij van huis gaat is maar
                  een klein deel van wat er bij je hond gebeurd. Hij laat dit
                  gedrag zien omdat hij stress ervaart. Deze stress is een
                  automatische lichamelijke reflex. Deze reflex wordt
                  veroorzaakt omdat ergens diep in zijn onderbewuste brein iets
                  verkeerd gaat. Dit zien we niet direct maar deze processen
                  bepalen al zijn emoties en gedragingen.
                </p>
                <p data-id="element-3589" data-mp="3a4bklq819tym">
                  Je kan het eigenlijk zien als een ijsberg in de zee. Het
                  blaffen, piepen en gedrag dat wij "verlatingsangst" noemen is
                  wat je ziet. Dit is de <strong data-id="element-3590" data-mp="3065jvbxyqtvc">10% van de ijsberg</strong> die
                  boven water drijft.
                </p>
                <p data-id="element-3591" data-mp="2w4trwzrm9wjz">
                  Dan zijn er zijn emoties en de spanning die hij ervaart. Als
                  je goed kijkt kan je dit herkennen. Dit is het deel onderwater
                  wat je nog kan zien. Dit is nog eens <strong data-id="element-3592" data-mp="2mehahgf3mji2">30%</strong>.
                </p>
                <p data-id="element-3593" data-mp="2hfxndcorr1o4">
                  Dan ligt er diep onderwater nog een heel groot deel van de
                  ijsberg. Dit zijn de onbewuste processen die voortkomen uit de
                  diepgewortelde behoeftes van je hond. Bij verlatingsangst is
                  er hier een kernprobleem. Dit is nog eens <strong data-id="element-3594" data-mp="23go6sbwni5jm">60%</strong>{' '}
                  van wat er eigenlijk aan de hand is.
                </p>
                <p className="font-bold text-white" data-id="element-3595" data-mp="iy3uimutds80">
                  Als je verlatingsangst wilt aanpakken dan moet je aan de slag
                  met de hele ijsberg. Niet alleen met het zichtbare gedrag.
                </p>
                <p data-id="element-3596" data-mp="rxh5jjyl6ouu">
                  Dus als je het kernprobleem niet oplost dan heeft oefenen maar
                  10% van het effect dat je wilt. Dat is waarom direct oefenen
                  zo langzaam gaat en je hond snel terugvalt in oud gedrag. Het
                  is dan alsof je de ijsberg even onder water hebt geduwd en hij
                  weer boven komt. Dit is wat andere methodes verkeerd doen. Ze
                  beginnen direct, of veel te snel met oefenen. Daarom gaat het
                  langzaam, blijft je hond terugvallen in gedrag en vindt er
                  geen echte verandering plaats.
                </p>
                <div className="mt-8 rounded-xl overflow-hidden" data-id="element-3597" data-mp="3ho4268ge12oi">
                  <img src="https://cdn.magicpatterns.com/uploads/dp1MNNz2c1oFtFSZvJECoy/7db3c11805f8570f0b6c849247d8d1b4.jpg" alt="Verlatingsangst IJsberg Theorie" className="w-full h-auto object-contain rounded-lg" data-id="element-3598" data-mp="2p3fy49knwjlw" />
                </div>
              </div>
            </div>

            {/* 13. ZO PAS JE HET TOE */}
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-6" data-id="element-3599" data-mp="330uophmnixfg">
              Zo pas je de Verlatingsangst Kernaanpak vandaag nog toe
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-3600" data-mp="2afben3dsc422">
              De Verlatingsangst Kernaanpak Methode wordt alleen door onze
              coaches gebruikt tijdens onze behandeltrajecten. Niemand in
              Nederland werkt nog op deze manier. Maar wij vinden dat ieder
              hondenbaasje dat worstelt met de verlatingsangst van zijn hond de
              kans zou moeten krijgen om hiermee aan de slag te gaan.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-12" data-id="element-3601" data-mp="1k499j7yts61l">
              Daarom hebben we een videotraining gemaakt voor je. In deze
              training doorlopen we in drie compacte lessen ieder van de drie
              essentiële stappen in deze aanpak.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-3602" data-mp="157a3hojmgl98">
              {[{
              title: 'Stap 1',
              text: 'Na stap 1 begrijp je de verschillende kernproblemen van verlatingsangst en hoe je zelf een diagnose doet zodat je zeker weet dat je niet werkt aan het verkeerde probleem.'
            }, {
              title: 'Stap 2',
              text: 'Na stap 2 snap je hoe je ieder van de kernproblemen oplost zodat je hond klaar is om te oefenen en met zekerheid door kan naar stap 3.'
            }, {
              title: 'Stap 3',
              text: 'En na stap 3 snap je hoe je effectief moet oefenen met je hond zodat je zo snel mogelijk resultaat hebt.'
            }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border-t-4 border-[#5ce0d2]" data-id="element-3603" data-mp="7ubwbxatdo3r" data-mpi={i}>
                  <h4 className="font-bold text-xl text-[#1a2b4a] mb-3" data-id="element-3604" data-mp="3q21bppf22tq3">
                    {les.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-3605" data-mp="mig5oanz8n9v">
                    {les.text}
                  </p>
                </div>)}
            </div>
            <p className="text-center font-bold text-gray-500 mb-16" data-id="element-3606" data-mp="ct6dkut4v4lr">
              Zet vandaag nog de eerste stap.
            </p>
          </div>

          {/* Right column - sticky sidebar */}
          <div className="hidden lg:block lg:col-span-4" data-id="element-3607" data-mp="hpwv7mkl689a">
            <div className="sticky top-8" data-id="element-3608" data-mp="15h2a9zipcwij">
              <div className="bg-white rounded-xl overflow-hidden shadow-xl border border-gray-200" data-id="element-3609" data-mp="1a8k7cchlucy8">
                {/* BIJ JE BESTELLING */}
                <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-black text-sm uppercase tracking-widest" data-id="element-3610" data-mp="1jmayzl156gi3">
                  BIJ JE BESTELLING
                </div>

                <div className="p-5" data-id="element-3611" data-mp="1tdfa29np5h7n">
                  {/* Product */}
                  <div className="flex gap-4 items-start mb-6" data-id="element-3612" data-mp="1oe2mtnswy84j">
                    <img src="https://cdn.magicpatterns.com/uploads/bPH8swctNa91LRo7t5rtnE/Verlatingangst_kernmethode_bonus_(3).png" alt="Verlatingsangst Kern Aanpak - Stappenplan" className="w-20 h-20 object-cover rounded-lg flex-shrink-0" data-id="element-3613" data-mp="1oeukd462mfxg" />
                    <div data-id="element-3614" data-mp="15nkydvf45yoz">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-3615" data-mp="15nbjb2vlxby2">
                        VERLATINGSANGST KERN AANPAK - STAPPENPLAN
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-3616" data-mp="2h304ppt7q2wr">
                        Gedetailleerde uitleg van hoe je de echte oorzaak van
                        verlatingsangst in 3 stappen oplost zonder dat hij
                        terugvalt in oud gedrag
                      </p>
                    </div>
                  </div>

                  {/* 5 FREE FAST ACTION BONUSES */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-5" data-id="element-3617" data-mp="14lxawgj9ofix">
                    3 x GRATIS BONUS
                  </div>

                  {/* Bonus 1 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-3618" data-mp="1ei0med00dqij">
                    <img src="https://cdn.magicpatterns.com/uploads/kK8kyQqoZHm31F5VUdBjhD/2.png" alt="30 Dagen Community Toegang" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-3619" data-mp="1j9s6q5skn008" />
                    <div data-id="element-3620" data-mp="1xa2yrc5makmz">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-3621" data-mp="1x9bdov9nc5ay">
                        30 DAGEN COMMUNITY TOEGANG
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-3622" data-mp="3ct0t4egoktjg">
                        Stuur vragen, foto's en videos naar onze experts, neem
                        deel aan meerdere wekelijkse online coachingsessies en
                        kom in contact met andere hondenbaasjes.
                      </p>
                    </div>
                  </div>

                  {/* Bonus 2 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-3623" data-mp="bvvyjlge76c">
                    <img src="https://cdn.magicpatterns.com/uploads/jpptdiaLg8Jy3uMEh1EZiz/3.png" alt="Gezonde hond in 12 weken training" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-3624" data-mp="dqho04ju3bh" />
                    <div data-id="element-3625" data-mp="o2rlfa2fsqaf">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-3626" data-mp="o31c6zvb31h6">
                        Gezonde hond in 12 weken training
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-3627" data-mp="127id3wqe3s10">
                        Methode om met natuurlijk hondenvoer en supplementen de
                        gezondheid van jouw hond in 12 weken te herstellen
                      </p>
                    </div>
                  </div>

                  {/* Bonus 3 */}
                  <div className="flex gap-3 items-start mb-6" data-id="element-3628" data-mp="jgihicoe3jyr">
                    <img src="https://cdn.magicpatterns.com/uploads/bbcA4WNP4wTigQiHJcajRX/4.png" alt="Stoomcursus Stressless Dog Methodes" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-3629" data-mp="jibro1y7ombi" />
                    <div data-id="element-3630" data-mp="ehnz3buc3xf6">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-3631" data-mp="eiz41ezinb7v">
                        Stoomcursus Stressless Dog Methodes
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-3632" data-mp="28udujy0cpeoo">
                        Mini training over verschillende Stressless Dogs
                        Methodes, technieken en vaardigheden voor stressvrij
                        wandelen, hondencommunicatie, en meer.
                      </p>
                    </div>
                  </div>

                  {/* RESULTATEN */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-4" data-id="element-3633" data-mp="25lkyuqd0qe1">
                    RESULTATEN VAN DE KERNAANPAK
                  </div>

                  {/* Vimeo video */}
                  <div className="rounded-lg overflow-hidden" data-id="element-3634" data-mp="pwr4pkzf82tm">
                    <div style={{
                    padding: '56.25% 0 0 0',
                    position: 'relative'
                  }} data-id="element-3635" data-mp="pu4tnbdbn56n">
                      <iframe src="https://player.vimeo.com/video/1158372685?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%'
                    }} title="Resultaten video" data-id="element-3636" data-mp="2rpoypk4xp1g5"></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 16. LETTER SECTION */}
      <section className="bg-white py-16" data-id="element-3637" data-mp="1rx05sfpnvw3v">
        <div className="max-w-6xl mx-auto px-4" data-id="element-3638" data-mp="1wujmdm9u0kyz">
          {/* Section headline */}
          <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] text-center mb-4" data-id="element-3639" data-mp="33accqzgpwuu9">
            RESULTATEN VAN DE KERNAANPAK
          </h2>
          <p className="text-center text-lg text-gray-700 max-w-3xl mx-auto mb-8" data-id="element-3640" data-mp="387lz268t8qdv">
            Dit is hoe ik honden met verlatingsangst help om stressvrij alleen
            thuis te blijven door eerst het onderliggende kernprobleem aan te
            pakken, dit maakt de verdere aanpak veel en veel makkelijker
          </p>

          <p className="text-xl font-bold text-[#5ce0d2] mb-12 text-center leading-relaxed max-w-3xl mx-auto" data-id="element-3641" data-mp="mtnujr70ky15">
            Deze aanpak is nieuw, compleet anders, en verschilt van de eerdere
            aanpakken die je tot nu toe kent - lees mijn verhaal hieronder over
            het ontstaan van de Verlatingsangst Kernaanpak
          </p>

          <div className="grid lg:grid-cols-12 gap-8" data-id="element-3642" data-mp="3wcy0ecroipe">
            {/* Left column - letter content */}
            <div className="lg:col-span-8" data-id="element-3643" data-mp="3v4ipu5fqc5sq">
              <div className="bg-[#faf5eb] rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100" data-id="element-3644" data-mp="3v5jxs11g8c68">
                <div className="prose prose-lg max-w-none text-gray-800" data-id="element-3645" data-mp="1y8tbo07w6z4a">
                  <p className="font-bold" data-id="element-3646" data-mp="1tcm5q7fhxnmc">
                    Beste toekomstige Verlatingsangst Kernaanpakker
                  </p>
                  <p data-id="element-3647" data-mp="2g3f2mtrbjmvp">
                    <strong data-id="element-3648" data-mp="2g3ylqdspghbb">Van:</strong> Amee Buijs
                  </p>
                  <p data-id="element-3649" data-mp="2usbive3j467e">
                    <strong data-id="element-3650" data-mp="2usunxu82z040">Re:</strong> De enige manier om verlatingsangst écht
                    op te lossen, is door je op het kernprobleem te focussen (en
                    niet op het oefenen).
                  </p>
                  <p data-id="element-3651" data-mp="224fctis2l1xy">
                    Misschien verbaast het je dat er een andere manier is dan
                    eindeloos oefenen waarmee je verlatingsangst sneller kunt
                    oplossen, met een minimale kans op terugval.
                  </p>
                  <p data-id="element-3652" data-mp="2730dfjb8hnmx">En dat is niet gek.</p>
                  <p data-id="element-3653" data-mp="2715s43w1vtib">
                    Want bijna alles wat je online vindt, draait om
                    symptoombestrijding: oefenschema's, sleutels rammelen, je
                    hond laten uitblaffen, of afleiden bij vertrek.
                  </p>
                  <p data-id="element-3654" data-mp="3q0vlm3r22x0k">
                    Geen van deze methodes focust zich op het échte,
                    onderliggende probleem.
                  </p>
                  <p data-id="element-3655" data-mp="3v1sz4314f2vq">
                    Waarom zou mijn verhaal dan wel waar zijn? Je kunt immers
                    niet alles geloven wat je op het internet leest.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] mt-8" data-id="element-3656" data-mp="3l2lpnqxibsdw">
                    Dus laat het me je bewijzen.
                  </p>
                  <div className="bg-white p-6 rounded-lg my-8 text-sm italic text-gray-600 border-l-4 border-gray-300" data-id="element-3657" data-mp="hlbupbduxqoo">
                    <strong data-id="element-3658" data-mp="3v01f95jdlvy">Maar lees eerst deze disclaimer:</strong> Ik heb het
                    voordeel van jarenlange ervaring en het doorbreken van oude
                    methodes. De gemiddelde persoon die een "zo-doe-je-dat"
                    methode volgt, behaalt weinig tot geen resultaten. Jouw
                    resultaten zijn afhankelijk van vele factoren, waaronder
                    vooral je bereidheid om te doen wat er in de methode staat.
                    Elke verandering vraagt om inzet en doorzettingsvermogen.
                    Als je daar niet toe bereid bent, dan is deze methode
                    misschien niet voor jou. Met dat gezegd, laat me je laten
                    zien hoe het anders kan.
                  </div>

                  <p className="font-bold text-2xl text-[#1a2b4a] mt-12 mb-6" data-id="element-3659" data-mp="r97fjhh366tb">
                    Ik werk met een compleet andere methode die ik nu met jou ga
                    delen.
                  </p>
                  <p data-id="element-3660" data-mp="ignlyvfnisfc">
                    Dit is dezelfde Verlatingsangst-Kernaanpak model die
                    honderden hondeneigenaren nu gebruiken om de paniek bij hun
                    hond écht op te lossen.
                  </p>
                  <p data-id="element-3661" data-mp="8heohslkuvo8">
                    Hierdoor krijgen zij hun spontane vrijheid terug, sneller
                    dan ze ooit voor mogelijk hielden.
                  </p>
                  <p data-id="element-3662" data-mp="3plvjl1nh16x5">
                    En het mooiste van alles? Ze bouwen een diepere, betere band
                    op met hun hond, gebaseerd op begrip in plaats van
                    frustratie.
                  </p>
                  <p className="font-bold" data-id="element-3663" data-mp="3ef58ijjuev7">
                    Dit is niet zomaar een stappenplan;
                  </p>
                  <p data-id="element-3664" data-mp="8aw344gjw7lh">
                    Het is een fundamenteel andere manier van denken over
                    verlatingsangst. We focussen ons niet op:
                  </p>
                  <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-3665" data-mp="3bu7c5bo636mi">
                    <li data-id="element-3666" data-mp="3gsigx7zluqxv">
                      Eindeloze, korte oefensessies die nergens toe leiden.
                    </li>
                    <li data-id="element-3667" data-mp="3ll1wublrly5u">Je hond negeren of laten blaffen tot hij stopt.</li>
                    <li data-id="element-3668" data-mp="2o31ucqyo249k">Trucjes om je hond af te leiden bij vertrek.</li>
                    <li data-id="element-3669" data-mp="2t2y0owuu67sa">
                      Standaard protocollen die geen rekening houden met jouw
                      unieke hond.
                    </li>
                  </ul>
                  <p className="font-bold text-xl text-[#5ce0d2] p-6 bg-[#e6f7f5] rounded-lg my-8" data-id="element-3670" data-mp="tnweml0gknw8">
                    In plaats daarvan doen we iets wat bijna niemand doet: we
                    beginnen met een diagnose om het échte kernprobleem te
                    vinden.
                  </p>
                  <p data-id="element-3671" data-mp="1hdgx72sp9j4z">
                    Dit is een compleet andere aanpak, en het heeft de kracht om
                    alles voor jou en je hond te veranderen. Ik weet dat dit
                    waar is, want het heeft alles voor mij veranderd.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-3672" data-mp="1ravc2xyz5zv6">
                    Hoe ik dit ontdekte: De "Cirkel van Wanhoop" bij mijn
                    klanten
                  </h3>
                  <p data-id="element-3673" data-mp="3t545ylutbm3j">
                    Als gedragsdeskundige zag ik dit patroon steeds terugkomen
                    bij mijn klanten. Ik noem het de "Cirkel van Wanhoop":
                  </p>
                  <div className="bg-white border border-gray-200 rounded-lg p-6 my-6 space-y-3 shadow-sm" data-id="element-3674" data-mp="23nz55un36djb">
                    <p data-id="element-3675" data-mp="28mtn6ud8by2d">
                      <strong data-id="element-3676" data-mp="1twcohirzbm96">Stap 1:</strong> Ze volgden online oefenschema's
                      en begonnen met 30 seconden de deur uit.
                    </p>
                    <p data-id="element-3677" data-mp="1yt2z3ql0lpn7">
                      <strong data-id="element-3678" data-mp="1kvo6ye3dn3rj">Stap 2:</strong> De hond blafte, dus ze gingen te
                      snel. Terug naar 10 seconden.
                    </p>
                    <p data-id="element-3679" data-mp="1pw2ezw4zadpk">
                      <strong data-id="element-3680" data-mp="1ps4up76nzg43">Stap 3:</strong> Na een week kon de hond een
                      minuut alleen zijn. Een klein succes!
                    </p>
                    <p data-id="element-3681" data-mp="1fxczub4gv7d0">
                      <strong data-id="element-3682" data-mp="1fwjxrnggd617">Stap 4:</strong> Ze probeerden vijf minuten, en de
                      hond raakte volledig in paniek.
                    </p>
                    <p data-id="element-3683" data-mp="3aakw8783br0r">
                      <strong data-id="element-3684" data-mp="3a91cu7r50zur">Stap 5:</strong> De buren klaagden. Ze voelden
                      zich slechte eigenaren.
                    </p>
                    <p data-id="element-3685" data-mp="33u2mxmf4xl5h">
                      <strong data-id="element-3686" data-mp="33tt5in85ombe">Stap 6:</strong> Ze gaven het op en regelden weer
                      een oppas voor elke boodschap.
                    </p>
                    <p data-id="element-3687" data-mp="2yx2ghaedigdu">
                      <strong data-id="element-3688" data-mp="2utnwk8nbdfv4">Stap 7:</strong> Na een paar weken frustratie
                      begonnen ze weer bij Stap 1.
                    </p>
                  </div>
                  <p data-id="element-3689" data-mp="3rlrgt77luhoj">
                    Ik zag hoe deze cirkel mijn klanten jarenlang gevangen
                    hield. Ze voelden zich machteloos en schuldig.
                  </p>
                  <p data-id="element-3690" data-mp="3hs0yyl5zh5ht">
                    Ik voelde me gefrustreerd omdat ik zag dat ik hen niet echt
                    hielp. Ik was aan het symptoombestrijden, niet aan het
                    oplossen.
                  </p>
                  <p data-id="element-3691" data-mp="9e22zjj0hk4b">
                    Ik stond op het punt om te geloven dat verlatingsangst bij
                    sommige honden gewoon onoplosbaar was.
                  </p>
                  <p data-id="element-3692" data-mp="1s2v8gog2ro7e">
                    Maar voordat ik dit opgaf, wilde ik nog één ding proberen.
                    Iets wat, als het zou werken, alles zou veranderen.
                  </p>
                  <p className="font-bold" data-id="element-3693" data-mp="213ky1aeqsico">En het werkte.</p>

                  <div className="my-12 flex flex-col md:flex-row gap-8 items-center" data-id="element-3694" data-mp="261mf5psly7li">
                    <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee Buijs" className="w-48 h-48 rounded-full object-cover shadow-xl border-4 border-white" data-id="element-3695" data-mp="2b0fulnrgg8ob" />
                    <div data-id="element-3696" data-mp="2opzw6q9auzw1">
                      <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-3697" data-mp="2oq9ia2r84mwg">
                        Mijn naam is Amee, en ik zag jouw frustratie bij al mijn
                        klanten.
                      </h3>
                      <div className="space-y-4" data-id="element-3698" data-mp="2ymw1yo7td7ww">
                        <p data-id="element-3699" data-mp="29l0f1suk581f">
                          Als gedragsdeskundige zag ik steeds dezelfde pijn.
                          Honden die ondanks alle liefde en zorg in pure paniek
                          raakten zodra de deur dichtging.
                        </p>
                        <p data-id="element-3700" data-mp="2ekmvsc9lh6ez">
                          Eigenaren, vooral vrouwen van 50+, die hun hele leven
                          om hun hond heen planden.
                        </p>
                        <p data-id="element-3701" data-mp="1lwr1fe7hzqld">
                          Geen spontaan kopje koffie met een vriendin, niet meer
                          naar yoga, altijd die knoop in je maag als je de deur
                          uit moest.
                        </p>
                      </div>
                    </div>
                  </div>

                  <p data-id="element-3702" data-mp="176jfupm71rgg">
                    Ze voelden zich gevangen in hun eigen huis, schuldig
                    tegenover hun hond, en bezwaard naar de omgeving die altijd
                    moest bijspringen.
                  </p>
                  <p data-id="element-3703" data-mp="t0rhsbs66reh">
                    En ik zag dat mijn standaard aanpak hen niet echt hielp.
                  </p>
                  <p data-id="element-3704" data-mp="j3wnk52xjd60">
                    Het keerpunt kwam bij een klant met een hond die meerdere
                    problemen had. We kregen de verlatingsangst niet opgelost
                    met de standaard aanpak.
                  </p>
                  <p data-id="element-3705" data-mp="1btlqwp343pas">
                    Pas toen we aan de slag gingen met een andere angst die hij
                    had – iets in zijn omgeving – gebeurde er iets magisch. De
                    verlatingsangst verdween daarna als sneeuw voor de zon.
                  </p>
                  <p data-id="element-3706" data-mp="16sxyq035d2ez">
                    Het was een Eureka-moment. Ineens viel alles op zijn plek.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] my-6" data-id="element-3707" data-mp="3mjtzojkniv6z">
                    Verlatingsangst was niet het probleem; het was een symptoom.
                  </p>
                  <p data-id="element-3708" data-mp="1zhu93k58xnnq">En dat veranderde alles in hoe ik werkte.</p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-3709" data-mp="1zgj4xj7w2dw3">
                    De #1 Fout die iedereen maakt: focussen op het symptoom
                  </h3>
                  <p data-id="element-3710" data-mp="1qjil7pvrl3yz">
                    De markt voor hondentraining is verdeeld in twee kampen. Je
                    hebt de "symptoombestrijders" en je hebt ons van Stressless
                    Dogs, wij zijn de "kernaanpakkers".
                  </p>
                  <p data-id="element-3711" data-mp="2n86sps9ut8u5">
                    Maar jarenlang was ik ook een symptoombestrijder. Ik
                    probeerde mijn klanten te helpen door het blaffen, piepen en
                    slopen af te leren.
                  </p>
                  <p data-id="element-3712" data-mp="2e5fddhduxsx8">
                    Maar het probleem is niet het gedrag zelf. Het probleem is
                    de onderliggende emotie die het gedrag veroorzaakt.
                  </p>
                  <p className="font-bold text-red-600" data-id="element-3713" data-mp="12tejjo24zeam">
                    Het gevaarlijkste advies dat je kunt krijgen, is "gewoon
                    oefenen en laten wennen".
                  </p>
                  <p data-id="element-3714" data-mp="q97tjmo9qtm6">
                    Waarom? Omdat je daarmee de onderliggende stress negeert.
                  </p>
                  <p data-id="element-3715" data-mp="146wdmsaihwq6">
                    Soms verergert het de situatie zelfs, waardoor de stress
                    overslaat op andere aspecten van het leven van je hond. Je
                    bent de paniek aan het managen, niet aan het oplossen.
                  </p>
                  <p data-id="element-3716" data-mp="6nbi5mgqyry5">
                    De oplossing gaat tegen je gevoel in: stop met focussen op
                    het oefenen van alleen zijn. In plaats daarvan richten we
                    ons op de wortel van het probleem.
                  </p>
                  <p data-id="element-3717" data-mp="3oyya1hd29qve">
                    Is het verveling? Trauma? Omgevingsangst? Of een van de
                    andere vijf kernproblemen?
                  </p>
                  <p className="font-bold" data-id="element-3718" data-mp="3jyk72dqbh748">
                    Zodra je de diagnose stelt en het kernprobleem aanpakt,
                    wordt het oefenen verrassend eenvoudig en effectief.
                  </p>

                  <h3 className="text-2xl font-black text-[#1a2b4a] mt-12 mb-8" data-id="element-3719" data-mp="1xnbjyqvvzd6v">
                    Wat je leert in deze training:
                  </h3>
                  <div className="space-y-6 not-prose" data-id="element-3720" data-mp="21nvernszm4pu">
                    {[{
                    title: 'Stap 1: De Diagnose',
                    text: 'Leer de verschillende oorzaken van verlatingsangst en hoe je ontdekt welke oorzaak bij jouw hond speelt.'
                  }, {
                    title: 'Stap 2: De Kernaanpak',
                    text: 'Krijg de tools om de specifieke kernproblemen op te lossen en een sterke, veerkrachtige basis te leggen voor je hond.'
                  }, {
                    title: 'Stap 3: Het Oefenen',
                    text: 'Leer hoe je stressvrij en effectief kunt oefenen, op een manier die past bij jouw hond, zodat je snel en blijvend resultaat boekt.'
                  }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 flex gap-4 items-start" data-id="element-3721" data-mp="2uq4v7ctmbjnv" data-mpi={i}>
                        <PlayCircle className="w-8 h-8 text-[#5ce0d2] flex-shrink-0 mt-1" data-id="element-3722" data-mp="2lrkn15loosdw" />
                        <div data-id="element-3723" data-mp="2gqwugfht43hk">
                          <h4 className="font-bold text-xl text-[#1a2b4a] mb-2" data-id="element-3724" data-mp="2gtrew70tloaz">
                            {les.title}
                          </h4>
                          <p className="text-gray-700 m-0" data-id="element-3725" data-mp="27rrzfj5gesa5">{les.text}</p>
                        </div>
                      </div>)}
                  </div>
                  <p className="text-gray-600 mt-8 italic" data-id="element-3726" data-mp="5zwo54n40psg">
                    Daarnaast krijg je toegang tot casestudies en interviews met
                    klanten, zodat je precies ziet hoe deze aanpak in de
                    praktijk werkt.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-3727" data-mp="hztwr9jsfhzy">
                    Voor wie is deze methode (niet)?
                  </h3>
                  <p data-id="element-3728" data-mp="82pal9pxzmj5">
                    Deze methode is <strong data-id="element-3729" data-mp="85tmkt9nfmkd">niet</strong> voor mensen die hun
                    hond zien als een robot die moet gehoorzamen. Het is niet
                    voor mensen die een snelle, magische oplossing zoeken zonder
                    bereid te zijn hun hond echt te begrijpen.
                  </p>
                  <p data-id="element-3730" data-mp="3ghh54p1pyr3p">
                    Deze methode is <strong data-id="element-3731" data-mp="3li3qg03cv8dg">voor jou</strong> als je je hond
                    ziet als een volwaardig gezinslid. Als je gelooft dat hij
                    emoties en gevoelens heeft die gerespecteerd moeten worden.
                    En als je bereid bent om het anders te doen, op een manier
                    die op de lange termijn beter is voor zowel jou als je hond.
                  </p>
                  <p className="text-xl font-bold text-[#5ce0d2] mt-8 mb-12" data-id="element-3732" data-mp="2nxlmusmquf83">
                    Als je klaar bent om de cirkel van wanhoop te doorbreken en
                    je vrijheid terug te krijgen, dan is dit het moment. Stop
                    met symptoombestrijding en start met de kernaanpak.
                  </p>

                  <div className="rounded-xl overflow-hidden shadow-lg mt-8" data-id="element-3733" data-mp="3btpzm5nnwznp">
                    <img src="https://cdn.magicpatterns.com/uploads/bEbEj36tRb2txwLv3vaAfN/freepik_man-en-vrouw-van-rond-de-_2777484675.png" alt="Man en vrouw kijken naar ontspannen hond" className="w-full h-auto object-cover" data-id="element-3734" data-mp="36wpsdrf2tqv0" />
                  </div>
                </div>
              </div>
            </div>

            {/* Right column - sticky sidebar */}
            <div className="lg:col-span-4" data-id="element-3735" data-mp="3pkcrbdv09paa">
              <div className="lg:sticky lg:top-8 space-y-6" data-id="element-3736" data-mp="2n9sxkdqf6vp5">
                {/* Product image */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-3737" data-mp="2s7b9mczqhr1d">
                  <img src="https://cdn.magicpatterns.com/uploads/wdHvRUEhLbVnqomgf29M7C/d2e92536bec5d1aca3fcae847f833a85.jpg" alt="Verlatingsangst Kernaanpak Training op verschillende apparaten" className="w-full h-auto object-contain" data-id="element-3738" data-mp="2w9g2vam9slnh" />
                </div>

                {/* Wat je krijgt */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-3739" data-mp="3fxykn74y4ws5">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-3740" data-mp="3jzsg910abalg">
                    Dit is wat je krijgt met de training
                  </div>
                  <div className="p-5 space-y-5" data-id="element-3741" data-mp="1pl9e4zjnn93y">
                    <div className="flex items-start gap-3" data-id="element-3742" data-mp="1pm0zzing9sh1">
                      <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-3743" data-mp="1i1gnzsx8is2g" />
                      <span className="text-sm font-bold text-gray-800" data-id="element-3744" data-mp="1db08m39uswdg">
                        Drie stappen kernaanpak om jouw hond te leren alleen
                        thuis te blijven
                      </span>
                    </div>

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-3745" data-mp="14bmv8zilznng">
                      Dit leer je in Les 1
                    </p>
                    {['Hoezo oefenen met alleen thuis zijn geen nut heeft als je niet eerst het onderliggende probleem aanpakt', 'Welke onderliggende kernproblemen er zijn bij verlatingsangst en welke er voor jouw hond waarschijnlijk speelt', 'Hoe je zelf een diagnose doet zodat je weet waarmee je eerst aan de slag moet'].map((item, i) => <div key={`l1-${i}`} className="flex items-start gap-3" data-id="element-3746" data-mp="bl4u441g3wco" data-mpi={i}>
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-3747" data-mp="2bnxf0ofm5n05" />
                        <span className="text-sm text-gray-700" data-id="element-3748" data-mp="2bqa2ti81yrl4">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-3749" data-mp="21q9h5pmpnzdr">
                      Dit leer je in Les 2
                    </p>
                    {['Hoe je een effectief behandelplan maakt voor jouw hond zodat je in de juiste volgorde aan de slag gaat', 'Wat je wel, en wat je juist niet moet oefenen zodat je geen tijd en energie stopt in de verkeerde dingen', 'Voorbeeld casus van hond Lemmy en hoe deze van totaal niet alleen kon zijn na 3 weken 3 uur alleen kon zijn met deze methode', 'Voorbeeld casus van honden Mork & Dash en hoe ook die hun verlatingsangst in korte tijd overwonnen met deze methode'].map((item, i) => <div key={`l2-${i}`} className="flex items-start gap-3" data-id="element-3750" data-mp="3i5asj66hidj9" data-mpi={i}>
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-3751" data-mp="16npn64j05r8o" />
                        <span className="text-sm text-gray-700" data-id="element-3752" data-mp="11ouywn29nah6">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-3753" data-mp="1fgj5ybxnr8ra">
                      Dit leer je in Les 3
                    </p>
                    {['Effectief oefenplan zodat je op de juiste manier zijn tijd alleen opbouwt', 'Drie voorbeeld behandel- en oefenplannen met verschillende onderliggende problemen'].map((item, i) => <div key={`l3-${i}`} className="flex items-start gap-3" data-id="element-3754" data-mp="woqfop9z41n9" data-mpi={i}>
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-3755" data-mp="rq6skljn8jtb" />
                        <span className="text-sm text-gray-700" data-id="element-3756" data-mp="284orv20g73sp">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-3757" data-mp="238zr4vcozgut">
                      Dit leer je in de bonus lessen
                    </p>
                    {['Herkennen van blafsoorten zodat je aan het type geblaf kan horen waarom hij blaft (angst, eenzaamheid, verveling, etc)', 'Stress signalen herkennen zodat je weet of je hond hoog of laag in zijn stress zit en het wel of geen goed moment is om te oefenen', '3 Kalmerende activiteiten waarmee je jouw hond kan helpen ontspannen als zijn stress level te hoog is'].map((item, i) => <div key={`bonus-${i}`} className="flex items-start gap-3" data-id="element-3758" data-mp="2rr4a14629jnw" data-mpi={i}>
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-3759" data-mp="2msaz9ji5s6rf" />
                        <span className="text-sm text-gray-700" data-id="element-3760" data-mp="3k9jh2od77nc7">{item}</span>
                      </div>)}
                  </div>
                </div>

                {/* First pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-3761" data-mp="3muheo1bun1ge">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-3762" data-mp="3rtk9yu211tb6">
                    Start met de Verlatingsangst Kernaanpak Methode
                  </div>
                  <div className="p-5 text-center" data-id="element-3763" data-mp="5i6lgeti9k1h">
                    <img src="https://cdn.magicpatterns.com/uploads/wdHvRUEhLbVnqomgf29M7C/d2e92536bec5d1aca3fcae847f833a85.jpg" alt="Verlatingsangst Kernaanpak Training" className="w-full h-auto object-contain mb-4 rounded-lg" data-id="element-3764" data-mp="9mmlw0kcnz9b" />
                    <div className="text-[#e53e3e] font-black text-3xl mb-1" data-id="element-3765" data-mp="o9fw4rf0ieun">
                      Slechts €27
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-3766" data-mp="t80x4t2392k5">
                      (Bespaar €70)
                    </div>
                    <p className="text-gray-600 text-sm mb-2" data-id="element-3767" data-mp="2uba5fzu0qfkx">
                      Start met de methode voor €27. Direct toegang. Begin met
                      stap 1 in slechts 2 minuten.
                    </p>
                    <p className="text-[#5ce0d2] font-bold text-sm mb-4" data-id="element-3768" data-mp="3356ov6vstdwn">
                      Per direct toegang.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-3769" data-mp="2ybu1f02uvd5h">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-3770" data-mp="3i2fh02sxelpf">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-3771" data-mp="1djodh4al8ghf">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-3772" data-mp="1hl1n7pgsx3tm">
                    Dit is wat anderen zeggen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-3773" data-mp="13rshpzvz52gd">
                    <img src="https://cdn.magicpatterns.com/uploads/qadgiKJVMEENSSwLSHdnib/Scherm­afbeelding_2026-04-13_om_16.11.42.png" alt="Review Marijke" className="w-full h-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-3774" data-mp="18s6cwhch8hwz" />
                    <img src="https://cdn.magicpatterns.com/uploads/pu6bXE2Mf7TwUeQJ5i8sft/Scherm­afbeelding_2026-04-13_om_16.11.31.png" alt="Review Lut Matthys" className="w-full h-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-3775" data-mp="kwc3rupj035j" />
                  </div>
                </div>

                {/* Second pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-3776" data-mp="k5dcls2rg734">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-3777" data-mp="f7btx898y9s6">
                    Start met de Verlatingsangst Kernaanpak Training
                  </div>
                  <div className="p-5 text-center" data-id="element-3778" data-mp="65kom4imc4yu">
                    <div className="text-[#e53e3e] font-black text-2xl mb-1" data-id="element-3779" data-mp="16re8kymou2w">
                      Slechts €27 vandaag
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-3780" data-mp="3sk464a2w409j">
                      (Bespaar €70)
                    </div>
                    <p className="text-gray-600 text-sm mb-4" data-id="element-3781" data-mp="3inizxlf4wj44">
                      Start met de methode voor €27. Direct toegang. Begin met
                      stap 1 in slechts 2 minuten.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-3782" data-mp="39mb1928phg9i">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-3783" data-mp="234kzc1dh9dz7">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Bonussen */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-3784" data-mp="1af4dxno9yxch">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-3785" data-mp="1feqt42nnynnx">
                    Inclusief Bonussen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-3786" data-mp="mqbdpf0me3c2">
                    {[{
                    title: '30 dagen community toegang',
                    desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies en kom in contact met andere hondenbaasjes."
                  }, {
                    title: 'Gezonde hond in 12 weken',
                    desc: 'Methode om met natuurlijk hondenvoer en supplementen de gezondheid van jouw hond in 12 weken te herstellen'
                  }, {
                    title: 'Stoomcursus Stressless Dog Methodes',
                    desc: 'Mini training over verschillende Stressless Dogs Methodes, technieken en vaardigheden voor stressvrij wandelen, hondencommunicatie, en meer.'
                  }].map((bonus, i) => <div key={`b-${i}`} className="flex items-start gap-3" data-id="element-3787" data-mp="1g29ssv2uu21p" data-mpi={i}>
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-3788" data-mp="2wgi0jjiyu6ta" />
                        <div data-id="element-3789" data-mp="2ripyvxsir6bw">
                          <p className="font-bold text-sm text-[#1a2b4a]" data-id="element-3790" data-mp="2rhexu5qgkcoh">
                            {bonus.title}
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-3791" data-mp="340u1lmwmcbzb">{bonus.desc}</p>
                        </div>
                      </div>)}
                  </div>
                </div>

                {/* Video Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-3792" data-mp="2v0x5j07wgau8">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-3793" data-mp="3ir18d5d9k6k6">
                    Video Testimonials & Interviews
                  </div>
                  <div className="p-5 space-y-4" data-id="element-3794" data-mp="390oq5jsx8ph7">
                    {['1158442858', '1158442995', '1158442918', '1158443130'].map(id => <div key={id} className="rounded-lg overflow-hidden shadow-sm" data-id="element-3795" data-mp="5hdbnx2jcy8s">
                        <iframe src={`https://player.vimeo.com/video/${id}?badge=0&autopause=0&player_id=0&app_id=58479`} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" className="w-full aspect-video" title={`Testimonial ${id}`} data-id="element-3796" data-mp="26dtc9khxk7dw"></iframe>
                      </div>)}
                  </div>
                </div>

                {/* Final CTA */}
                <div className="bg-[#e6f7f5] rounded-xl p-5 text-center border border-[#5ce0d2]" data-id="element-3797" data-mp="2kazsb7b9rrzf">
                  <p className="font-bold text-[#1a2b4a] text-sm mb-3" data-id="element-3798" data-mp="2gd22q3dl73vi">
                    3 stappen tot je hond ontspannen alleen kan blijven
                  </p>
                  <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className="block w-full bg-[#5ce0d2] hover:bg-[#4bc9bd] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-md text-sm" data-id="element-3799" data-mp="14wtvvpr4h6e1">
                    Start nu met de Verlatingsangst Kernaanpak
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 19. GUARANTEE */}
      <section className="bg-[#1a2b4a] text-white py-16" data-id="element-3800" data-mp="3pdtxy8ld6zhk">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-3801" data-mp="3u9r4jn6tsrh5">
          <img src="https://cdn.magicpatterns.com/uploads/tPvpNvykR2KiCNK1pkG2LG/1a50ac51aa1d734ab9af0a73cc65b51b.png" alt="100% Money Back Guarantee" className="w-32 h-32 mx-auto mb-6 object-contain" data-id="element-3802" data-mp="34ixw8yckbah" />
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-[#ffb800]" data-id="element-3803" data-mp="c3wcfg1bvq22">
            De BESTE Geld-Terug Garantie In De Wereld
          </h2>
          <h3 className="text-2xl font-bold mb-8" data-id="element-3804" data-mp="2dwkhzw1g2pl0">
            365 dagen niet-goed, geld-terug garantie:
          </h3>
          <div className="text-lg text-gray-300 leading-relaxed space-y-6 max-w-3xl mx-auto text-left" data-id="element-3805" data-mp="1xqc82x4053rs">
            <p data-id="element-3806" data-mp="22o5ftukye5u6">
              Kijk, laat me eerlijk tegen je zijn: Ik weet dat voordat ik ergens
              induik… …ik zelf ook wil weten wat ik koop en dat het wordt
              ondersteund door een sterke geld-terug-garantie. En ik wil dat jij
              je comfortabel voelt bij deze aankoop. Ook al is het maar €27 –
              jij hebt voor dat geld gewerkt en het telt.
            </p>
            <p data-id="element-3807" data-mp="2len4no2o0ha9">
              Zoals mijn opa altijd zei: "Maak eerst een proefrit, voordat je de
              auto van het terrein afrijdt." Maar hier zit het verschil. Waar de
              meeste mensen je maximaal een garantie van 14 of 30 dagen zouden
              geven… ga ik iets doen wat je waarschijnlijk nog nooit hebt
              gezien.
            </p>
            <p className="font-bold text-white text-xl text-center py-4" data-id="element-3808" data-mp="10zjuc64jjnt6">
              Ik geef je een 365 dagen om de Verlatingsangst Kernaanpak Training
              te bekijken en toe te passen.
            </p>
            <p data-id="element-3809" data-mp="oosifked5gh1">
              Ja, je leest het goed. Je krijgt een heel JAAR om deze korte
              training te volgen en toe te passen wat je erin leert. Niet
              slechts een paar weken of een maand. En als je niet volledig
              overdonderd bent door wat je leert… Dan stuur je me gewoon een
              e-mail en vraag je op elk moment binnen die 365 dagen je geld
              terug. We storten je €27 direct terug en je mag toegang tot de
              cursus gratis houden.
            </p>
            <p className="text-center italic mt-8" data-id="element-3810" data-mp="12fpa990gttn1">
              Omdat je nu nog aan het gelezen ben, neem ik aan dat je klaar bent
              om te bestellen, dus met die gedachten...
            </p>
          </div>
        </div>
      </section>

      {/* 20. PRICING CTA */}
      <section className="bg-white py-16 border-b border-gray-200" data-id="element-3811" data-mp="3i7d2ir4jaxzi">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-3812" data-mp="3ia7myinjsisx">
          <h2 className="text-4xl font-black text-[#1a2b4a] mb-2" data-id="element-3813" data-mp="2a9qqg1oeqe1o">
            Vandaag voor €27
          </h2>
          <h3 className="text-2xl font-bold text-[#e53e3e] mb-6" data-id="element-3814" data-mp="2e980z9ioy1dp">
            (Bespaar €70)
          </h3>
          <img src="https://cdn.magicpatterns.com/uploads/cn6aNStyPs26sEQni2fyTV/Ontwerp_zonder_titel_(21).jpg" alt="Verlatingsangst Kernaanpak Stappenplan" className="w-full max-w-md mx-auto mb-8 mix-blend-multiply" data-id="element-3815" data-mp="209zurwo41t00" />
          <p className="text-lg text-gray-600 mb-8" data-id="element-3816" data-mp="1vc6rpci3tf3y">
            Start met de Verlatingsangst Kernaanpak voor{' '}
            <span className="line-through" data-id="element-3817" data-mp="1hlbg3sg80jwo">€97</span> slechts €27! Direct
            toegang tot online lesmateriaal. Neem de eerste stap in 2 minuten.
          </p>
          <div className="max-w-md mx-auto" data-id="element-3818" data-mp="17l2j4ceemug8">
            <CTAButton data-id="element-3819" data-mp="17mcg0y9itwla" />
            <p className="text-sm text-gray-500 mt-4 font-bold" data-id="element-3820" data-mp="1cknrfdfgsf5m">
              Met 365 dagen 100% geld terug garantie.
            </p>
          </div>
        </div>
      </section>

      {/* 21. WHAT YOU GET GRID */}
      <section className="bg-[#faf5eb] py-16" data-id="element-3821" data-mp="oxjuxeyvyyfw">
        <div className="max-w-6xl mx-auto px-4" data-id="element-3822" data-mp="oyuypesc0670">
          <h2 className="text-3xl font-black text-[#1a2b4a] text-center mb-12" data-id="element-3823" data-mp="12wrzkndtiyrh">
            Dit is wat je krijgt met de training
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-3824" data-mp="xwdnmu93j4o6">
            {[{
            title: 'Verlatingsangst Kernaanpak Methode',
            desc: 'Volledige training in hoe je de Verlatingsangst Kernaanpak inzet.',
            image: 'https://cdn.magicpatterns.com/uploads/d7mvv6jB1XyRHfPv1QLUbd/Verlatingangst_kernmethode_bonus_(2).png'
          }, {
            title: '30 dagen ondersteuning via Community',
            desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies.",
            image: 'https://cdn.magicpatterns.com/uploads/8mzMhue5NATuWpex23cfs6/2.png'
          }, {
            title: 'Stoomcursus Stressless Dog Methodes',
            desc: 'Mini training over verschillende Stressless Dogs Methodes, technieken en vaardigheden voor stressvrij wandelen, hondencommunicatie, en meer.',
            image: 'https://cdn.magicpatterns.com/uploads/5xTMXACWhxH6FRP25sk6Rf/4.png'
          }, {
            title: 'Gezonde hond in 12 weken training',
            desc: 'Methode om met natuurlijk hondenvoer en supplementen de gezondheid van jouw hond in 12 weken te herstellen.',
            image: 'https://cdn.magicpatterns.com/uploads/dAT5SmJ1D7wjLPsXTfaXi4/3.png'
          }].map((item, i) => <div key={i} className="bg-white rounded-xl overflow-hidden shadow-md flex flex-col h-full" data-id="element-3825" data-mp="qdxnc8n0u7kf" data-mpi={i}>
                <div className="bg-[#5ce0d2] text-[#1a2b4a] font-bold text-center py-2 text-xs uppercase tracking-wider" data-id="element-3826" data-mp="2fvb9zh8ulvrz">
                  INBEGREPEN BIJ JE BESTELLING
                </div>
                <div className="p-6 flex-1 flex flex-col" data-id="element-3827" data-mp="265i1wq7wzysh">
                  <div className="w-full h-48 rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-3828" data-mp="263x7d0llofum">
                    <img src={item.image} alt={item.title} className="w-full h-full object-contain" data-id="element-3829" data-mp="214kkifuqb8s1" />
                  </div>
                  <h4 className="font-bold text-[#1a2b4a] mb-2 leading-tight" data-id="element-3830" data-mp="1s8cvuq87azx8">
                    {item.title}
                  </h4>
                  <p className="text-sm text-gray-600 mt-auto" data-id="element-3831" data-mp="1i8m4uyiun31w">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 22. BOTTOM CTA BAR */}
      <div className="bg-[#ffb800] py-8 text-center px-4" data-id="element-3832" data-mp="3cmvgzcefoxdp">
        <div className="max-w-md mx-auto" data-id="element-3833" data-mp="1awo8eariqwsk">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className="block w-full bg-[#1a2b4a] hover:bg-black text-white font-bold py-4 px-4 rounded-lg text-xl transition-colors shadow-lg" data-id="element-3834" data-mp="1avwagtag8mz4">
            Krijg nu toegang!
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-3835" data-mp="15yczq3cymsbx">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 24. TURID RUGAAS QUOTE */}
      <section className="bg-white py-16" data-id="element-3836" data-mp="1yl7gap6np7k4">
        <div className="max-w-4xl mx-auto px-4 flex flex-col md:flex-row items-center gap-8" data-id="element-3837" data-mp="1yjwdarl1c3u2">
          <div className="flex-1 text-center md:text-left" data-id="element-3838" data-mp="1jr2nodc1u7bo">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-3839" data-mp="1omrnmhrzdq8i">
              Meestal zijn wij, de menselijke soort, degenen die conflicten
              creëren tussen onze honden en onszelf
            </h2>
            <p className="text-lg text-gray-700 mb-2" data-id="element-3840" data-mp="d6jh659fhurk">
              <strong data-id="element-3841" data-mp="2rfm3fwg40dqi">Turid Rugaas</strong>, wereldberoemde Noorse
              hondentrainster, auteur en expert in hondentaal
            </p>
            <p className="text-xs text-gray-400 uppercase tracking-wide" data-id="element-3842" data-mp="2mjybxae5n8hu">
              DISCLAIMER: Dit is geen aanbeveling van Turid Rugaas
            </p>
          </div>
          <div className="w-48 h-48 flex-shrink-0" data-id="element-3843" data-mp="2wg9p02lkk2dc">
            <img src="https://cdn.magicpatterns.com/uploads/5u3DrMLHNnG7KPDoQAwX5E/e34559c94a8bf7103f4c6cb20d81f245.jpg" alt="Turid Rugaas" className="w-full h-full object-cover rounded-xl shadow-lg grayscale" data-id="element-3844" data-mp="28pxj0x9vwfpe" />
          </div>
        </div>
      </section>

      {/* 25. FAQ */}
      <section className="bg-[#faf5eb] py-16" data-id="element-3845" data-mp="2cqzaut1h1phc">
        <div className="max-w-5xl mx-auto px-4" data-id="element-3846" data-mp="1p26nvm2turyv">
          <h2 className="text-4xl font-black text-[#1a2b4a] text-center mb-16" data-id="element-3847" data-mp="1p0vkvoh7ho8t">
            Veelgestelde vragen
          </h2>
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-3848" data-mp="1l0cs9s7hoe5k">
            {[{
            q: 'Ik wil dit, wat krijg ik exact?',
            a: 'Na je aankoop ontvang je een email met een inlogcode tot ons leerplatform. In dit platform vindt je drie uitgebreide lessen waarin je alles leert over de verlatingsangst kernaanpak.'
          }, {
            q: 'Wat is de Verlatingsangst Kernaanpak?',
            a: 'Dit is een nieuwe methode waarin je het onderliggende kernprobleem van verlatingsangst aanpakt in plaats van je alleen maar te richten op oefenen. Wij gebruiken deze methode om jaarlijks bij honderden honden verlatingsangst bij de kern aan te pakken en op te lossen.'
          }, {
            q: 'Kan ik meer hulp krijgen als ik dit wil?',
            a: 'Ja, er is een knop om in contact te komen met iemand van ons team die je meer kan uitleggen over onze 1-op-1 hulp.'
          }, {
            q: 'Wat maakt dit anders dan alle andere informatie online?',
            a: "Alles wat je kan vinden gaat alleen maar over oefen schema's en verschillende methodes van oefenen. Met deze methode kijk je naar het type verlatingsangst dat je hond heeft, pak je dat bij de kern aan en ga je daarna pas oefenen. Op deze manier heb je sneller, beter en blijvend resultaat."
          }, {
            q: 'Voor wie is dit?',
            a: 'Dit is voor hondenbaasjes die de verlatingsangst van hun hond nu voor eens en altijd willen oplossen en dit op een empatische manier willen doen.'
          }, {
            q: 'Is er een garantie?',
            a: 'Ja, je krijgt een 365 dagen niet-goed, geld-terug garantie voor het geval je toch niet tevreden bent.'
          }].map((faq, i) => <div key={i} data-id="element-3849" data-mp="w0x6s981y7hf" data-mpi={i}>
                <h4 className="font-bold text-xl text-[#1a2b4a] mb-3 flex items-start gap-3" data-id="element-3850" data-mp="w171ga41l2tg">
                  <HelpCircle className="w-6 h-6 text-[#5ce0d2] flex-shrink-0 mt-0.5" data-id="element-3851" data-mp="r6t07r2p81gv" />
                  {faq.q}
                </h4>
                <p className="text-[#5ce0d2] pl-9 leading-relaxed" data-id="element-3852" data-mp="1nyy4d92g9tmx">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 26. FINAL CTA */}
      <div className="bg-[#ffb800] py-12 text-center px-4" data-id="element-3853" data-mp="1xwm4keitrtch">
        <div className="max-w-md mx-auto" data-id="element-3854" data-mp="1xvaxa4q683gm">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className="block w-full bg-transparent border-4 border-[#1a2b4a] text-[#1a2b4a] hover:bg-[#1a2b4a] hover:text-white font-black py-4 px-4 rounded-lg text-2xl transition-colors" data-id="element-3855" data-mp="2bw3vp0jlfip0">
            Start met deze methode
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-3856" data-mp="2gnvntfiedwh9">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 27. FOOTER */}
      <footer className="bg-[#111827] text-gray-400 py-12 text-xs leading-relaxed text-center px-4" data-id="element-3857" data-mp="2qmkv6eco3yj9">
        <div className="max-w-5xl mx-auto space-y-6" data-id="element-3858" data-mp="39avdsja1rm8a">
          <p className="font-bold text-white mb-8" data-id="element-3859" data-mp="3e8okrej6ck9m">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, This site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>

          <div className="flex flex-col md:flex-row justify-between items-center gap-6 border-y border-gray-800 py-8 mb-8" data-id="element-3860" data-mp="35a31ti9sj38b">
            <p className="font-bold text-white" data-id="element-3861" data-mp="2v9ix25n2bglc">
              Copywriting van Stressless Dogs Nederland BV
            </p>
            <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className="bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-8 rounded-lg text-lg transition-colors" data-id="element-3862" data-mp="2hj74k5mkffto">
              Start met de training.
            </a>
          </div>

          <p className="text-justify" data-id="element-3863" data-mp="2chzxy9w5smol">
            We can not and do not make any guarantees about your ability to get
            results or earn any money with our ideas, information, tools, or
            strategies. What we can guarantee is your satisfaction with our
            training. We give you a 30-day 100% satisfaction guarantee on the
            products we sell, so if you are not happy for any reason with the
            quality of our training, just ask for your money back. You should
            know that all products and services by our company are for
            educational and informational purposes only. Nothing on this page,
            any of our websites, or any of our content or curriculum is a
            promise or guarantee of results or future earnings, and we do not
            offer any legal, medical, tax or other professional advice. Any
            financial numbers referenced here, or on any of our sites, are
            illustrative of concepts only and should not be considered average
            earnings, exact earnings, or promises for actual or future
            performance. Use caution and always consult your accountant, lawyer
            or professional advisor before acting on this or any information
            related to a lifestyle change or your business or finances. You
            alone are responsible and accountable for your decisions, actions
            and results in life, and by your registration here you agree not to
            attempt to hold us liable for your decisions, actions or results, at
            any time, under any circumstance.
          </p>
        </div>
      </footer>

      {/* 23. STICKY BOTTOM BAR */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#1a2b4a] border-t-4 border-[#5ce0d2] p-3 flex items-center justify-center shadow-[0_-4px_20px_rgba(0,0,0,0.3)]" data-id="element-3864" data-mp="3qdon02eep6id">
        <div className="flex items-center justify-between md:justify-center gap-3 md:gap-8 w-full max-w-5xl" data-id="element-3865" data-mp="1vzvyb1nlhaps">
          <div className="flex items-center gap-3 md:gap-6" data-id="element-3866" data-mp="20z0a801wlmjt">
            <img src="https://cdn.magicpatterns.com/uploads/oxTbd4Fk83NKokLatjZK4s/Verlatingangst_kernmethode_bonus_(4).png" alt="Verlatingsangst Kernaanpak Boek" className="hidden md:block w-16 h-auto object-contain" data-id="element-3867" data-mp="3rf2khtp7kiiq" />
            <img src="https://cdn.magicpatterns.com/uploads/cRmnco8rsPRXFAp45VMFKA/Ontwerp_zonder_titel_(70).png" alt="Verlatingsangst Kernaanpak" className="w-16 md:w-24 h-auto object-contain" data-id="element-3868" data-mp="48ij6qrpd882" />
            <div data-id="element-3869" data-mp="33qrob3ugj70s">
              <div className="text-white font-bold text-sm md:text-base leading-tight" data-id="element-3870" data-mp="33rb7envug1ge">
                Verlatingsangst Kernaanpak
              </div>
              <div className="text-[#5ce0d2] font-black text-lg md:text-xl" data-id="element-3871" data-mp="3cqojlobcr44t">
                <span className="text-red-500 line-through decoration-[3px] mr-2" data-id="element-3872" data-mp="3colia84r1oks">
                  €97
                </span>
                €27
              </div>
            </div>
          </div>
          <a href="https://afrekenen.stresslessdogs.nl/checkout/verlatingsangst-kernaanpak" className="bg-[#ffb800] text-[#1a2b4a] font-bold py-2 px-6 md:px-8 md:py-3 rounded-lg text-sm md:text-base shadow-md whitespace-nowrap" data-id="element-3873" data-mp="2jzwq4ylo8tl6">
            Naar Stap #2
          </a>
        </div>
      </div>
    </div>;
}